import { articles } from '@/mocks/articles';

const envSiteUrl: string | undefined = import.meta.env.VITE_SITE_URL;

export const SITE_ORIGIN: string = envSiteUrl || 'https://allchinabuyspread.beer';

export const SITE_NAME = 'AllChinaBuy Spreadsheet';

export const HOME_SEO = {
  title: 'AllChinaBuy Spreadsheet 2026 | Finds, Links & Buying Guide',
  description:
    'Explore the AllChinaBuy Spreadsheet with product finds, useful links, QC tips, shipping guides, reviews and buying resources for smarter international shopping.',
  keywords:
    'AllChinaBuy Spreadsheet, AllChinaBuy finds, AllChinaBuy links, AllChinaBuy buying guide, AllChinaBuy review, AllChinaBuy shipping, AllChinaBuy QC',
};

export const HOME_OG_IMAGE =
  'https://readdy.ai/api/search-image?query=a%20vibrant%20editorial%20flat%20lay%20of%20colorful%20sneakers%20hoodies%20and%20accessories%20artfully%20arranged%20on%20a%20warm%20terracotta%20backdrop%20with%20bold%20soft%20shadows%20and%20modern%20streetwear%20styling&width=1600&height=900&seq=hero-main-01&orientation=landscape&nocache=true';

export type SeoKind = 'home' | 'article';

export interface ResolvedSeo {
  kind: SeoKind;
  title: string;
  description: string;
  keywords: string;
  canonical: string;
  ogType: string;
  ogImage?: string;
  articleId?: string;
}

const LANGUAGE_PREFIXES = ['en', 'fr', 'de', 'da'];

function stripLanguagePrefix(pathname: string): string {
  const parts = pathname.split('/').filter(Boolean);
  if (parts.length > 0 && LANGUAGE_PREFIXES.includes(parts[0])) {
    return `/${parts.slice(1).join('/')}`;
  }
  return pathname;
}

export function resolveSeo(pathname: string): ResolvedSeo {
  const normalized = stripLanguagePrefix(pathname);

  if (normalized.startsWith('/article/')) {
    const id = normalized.split('/').filter(Boolean)[1];
    const article = articles.find((a) => a.id === id);
    if (article) {
      return {
        kind: 'article',
        title: article.title,
        description: article.excerpt,
        keywords: `${article.title}, AllChinaBuy Spreadsheet, AllChinaBuy guide, AllChinaBuy review, AllChinaBuy shipping`,
        canonical: `${SITE_ORIGIN}/article/${article.id}`,
        ogType: 'article',
        ogImage: article.image,
        articleId: article.id,
      };
    }
  }

  return {
    kind: 'home',
    title: HOME_SEO.title,
    description: HOME_SEO.description,
    keywords: HOME_SEO.keywords,
    canonical: `${SITE_ORIGIN}/`,
    ogType: 'website',
    ogImage: HOME_OG_IMAGE,
  };
}